import persist from './persist'
import axios from 'axios'
// import { NotUnique } from '../errors/bucketErrors'
// import { axapi } from '../helpers/axinstance'
// import router from '../router/index'

export default {
  state: {
    accounts: [],
  },
  mutations: {
    SAVE_ACCOUNTS (state, payload) {
      state.accounts = payload
    },
  },
  actions: {
    // Customer Accounts
    async getAccount ({ state, commit, dispatch }, payload) {
      try {
        const params = payload.params ? payload.params : {}
        const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/api/v1/account/${payload.key}`, { params: params })
        console.log(data)
        // state.accounts = data
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },
    async getAccounts ({ state, commit, dispatch }) {
      try {
        console.log('Retrieving accounts...')
        const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/api/v1/account/`)
        console.log(data)
        commit('SAVE_ACCOUNTS', data)
        // state.accounts = data
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },

    // Invoices
    async getUnpaidInvoices ({ state, commit, dispatch }, payload) {
      try {
        console.log('Retrieving account invoices...')
        const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/api/v1/account/invoice`, { params: payload })
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },
    async getECheckInfo ({ state, commit, dispatch }, payload) {
      try {
        console.log('Retrieving e-check info...', payload)
        const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/api/v1/platypus/get-echeck-info`, { params: payload })
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },
    async updateECheckInfo ({ state, commit, dispatch }, payload) {
      try {
        console.log('Updating e-check info...', payload)
        const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/api/v1/platypus/update-echeck-info`, payload)
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },
    /***
     * @param state
     * @param commit
     * @param dispatch
     * @param payload
     * @returns {Promise<*[]|any>}
     */
    async getCreditCardInfo ({ state, commit, dispatch }, payload) {
      try {
        console.log('Retrieving credit card info...', payload)
        const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/api/v1/platypus/get-cc-info`, { params: payload })
        console.log(data)
        return data
      } catch (error) {
        await dispatch('processAxiosError', error)
        console.log(error)
        return []
      }
    },

  },
  getters: {
    accounts: state => state.accounts,
  },
  plugins: [persist.plugin],
}
